import {h} from 'preact';

export default function Metric (props) {
  let total = Object.entries(props.component.data.factMap).reduce((acc, ele) => {
    return acc + ele[1].aggregates.reduce((subAcc, subEle) => {return subAcc + subEle.value}, 0);
  }, 0);


  const formatNumber = (x) => {
    // Comma formatting
    let result = x;

    // Round numbers
    if(props.component.meta.properties.visualizationProperties.displayUnits == 'whole') {
      result = Math.round(result);
    }

    // Add commas
    result = result.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Currency formatting
    const columnInfo = Object.values(props.component.data.reportExtendedMetadata.aggregateColumnInfo);
    if(columnInfo[0].dataType == 'currency'){
      return `$${result}`;
    }

    return result;
  }


  return (
    <div class={"container--type__" + props.type}>
    { props.component.meta.header &&
       <p class="container--header">{props.component.meta.header}</p>
    }
      <p class="h2 countup">{formatNumber(total)}</p>
    { props.component.meta.footer &&
      <p class="container--footer">{props.component.meta.footer}</p>
    }
    </div>
  );
}
